<div class="header">
    <div class="row">
      <div class="col-md">
        <h3>{{'MENU.EMAIL-DASHBOARD' | translate}}</h3>
        <h6>{{'CHART.TOTAL' | translate}}: {{emailTotal}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
      </div>
    </div>
  </div>


  <div class="row mr-0">

    <div class="col-3  d-flex flex-row">
      <div class="ts-box sentChart flex-column" [ngClass]="{'selected-sentChart': docType === 'sent'}"
           (click)="loadData('sent', 'success')" style="overflow: hidden">
        <h5 class="text-center mt-2 mb-0">{{'EMAIL-DASHBOARD.SENT' | translate}}</h5>
        <div class="canvas mt-4">
          <canvas id="sentChart">{{myChart1}}</canvas>
        </div>
        <h6 class="text-center mb-2">{{transactions_sent}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
      </div>
      <div class="ts-box errorsChart flex-column" [ngClass]="{'selected-errorsChart': docType === 'errors'}"
           (click)="loadData('errors', 'failed')" style="overflow: hidden">
        <h5 class="text-center mt-2 mb-0">{{'EMAIL-DASHBOARD.FAILED' | translate}}</h5>
        <div class="canvas mt-4">
          <canvas id="errorChart">{{myChart2}}</canvas>
        </div>
        <h6 class="text-center mb-2">{{transactions_failed}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
      </div>


    </div>


    <div class="box-filter col-9">
      <div class="col-12 searchBox_inner">
        <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>
      </div>
      <table width="100%">
        <tbody>
       <tr>
         <td style="width: 40%"><div class="">
        <div class="dropdown-label-group" >
        <p-dropdown
          class="dv-dropdown"
          selectId="company"
          [options]="company"
          [(ngModel)]="selectedCompany"
          (onChange)="filterBranchList()"
          [autoDisplayFirst]="false"
          id="company"
          placeholder="{{'FILTER.COMPANY' | translate}}"
          [style]="{'z-index': 3}"
        >
        </p-dropdown>
        <label for="company">{{'FILTER.COMPANY' | translate}}</label>
      </div>
      </div>
         </td>
         <td>

      <div width="30%">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="companyBranch"
          [options]="branchList"
          [(ngModel)]="selectedBranch"
          [autoDisplayFirst]="false"
          id="branch"
          placeholder="{{'FILTER.BRANCH' | translate}}"
        >
        </p-dropdown>
        <label for="companyBranch">{{'FILTER.BRANCH' | translate}}</label>
      </div>
    </div>
         </td>
         <td width="30%">
           <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
                 ngbDropdownToggle placeholder="{{'FILTER.DATE-OF-ISSUE' | translate}}" readonly>
          <label for="calendarDropdown">{{'FILTER.DATE-OF-ISSUE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); sentdate(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>
         </td>
       </tr>
        <tr>
        </tr>
        </tbody>
      </table>
      <table width="100%">
        <tbody>
        <tr>
          <td style="width: 40%">
            <div class=""style="margin-top: -10px">
        <div class="dropdown-label-group">
         <p-dropdown
          class="dv-dropdown"
          selectId="documentType"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [autoDisplayFirst]="false"
          id="documentType"
          placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}"
        >
        </p-dropdown>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
    </div></td>
          <td class="center" style="width: 60%">
            <div style="padding-top: 5px">
      <div class="form-label-group form-group">
        <input class="form-control" type="text" id="email" [(ngModel)]="email"
               placeholder="{{ 'EMAIL-DASHBOARD.EMAIL' | translate }}">
        <label for="email">{{ 'EMAIL-DASHBOARD.EMAIL' | translate }}</label>
      </div>
    </div>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>

<div class="col-12 box-parent  mt-3 pr-0 pl-0">
  <div class="pl-2">
   <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"

  >
  </app-custom-pagination>
  </div>

  <div class="row m-t-20" *ngIf="totalItems === 0 && loading_main === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>


   <div class="col-12 m-t-20  scrollable padding-left pl-0 pr-0" *ngIf="!loading_main&&totalItems !== 0">
    <table class="table text-center" >
      <thead >

          <th scope="col">{{'FILTER.DATE' | translate}}</th>
<!--          <th scope="col">Document No</th>-->
          <th scope="col">{{'FILTER.CUSTOMER-CODE' | translate}}</th>
          <th scope="col">{{'FILTER.DELIVERY-CODE' | translate}}</th>
          <th scope="col">{{'NORMAL.EMAIL' | translate}}</th>
          <th scope="col">{{'NORMAL.CC' | translate}}</th>
          <th scope="col">{{'FILTER.DOCUMENT-TYPE' | translate}}</th>
          <th scope="col">{{'EMAIL-DASHBOARD.STATUS' | translate}}</th>
      </thead>
      <tbody >

        <tr *ngFor="let res of datastatus; let i = index" >
            <td class="align-top">{{res.document_date| date:"dd/MM/yyyy"}}</td>
            <td class="align-top">{{res.customer_code}}</td>
            <td class="align-top">{{res.delivery_code}}</td>
            <td class="text-left">
              <ul *ngFor="let res of res.email_data; let i = index">
                <li>
                  {{res}}
                </li>
              </ul>
            </td>
            <td class="text-left">
              <ul *ngFor="let res of res.cc_email_data; let i = index">
                <li>
                  {{res}}
                </li>
              </ul>
            </td>
            <td class="align-top">{{res.document_type}}</td>
<!--            <td class="align-top">{{res.status}}</td>-->
            <td class="align-top" *ngIf="res.status=='failed'"><i class="fa fa-circle" style="color: #FF6384" aria-hidden="true"></i></td>
            <td class="align-top" *ngIf="res.status=='success'"><i class="fa fa-circle" style="color: #16c8c8" aria-hidden="true"></i></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row m-t-20" *ngIf="loading_main">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
  </div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.html